<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-3">
                <router-link
                  :to="{ name: 'Remissions' }"
                  class="btn btn-outline-secondary btn-sm"
                >
                  <i class="fas fa-arrow-left me-1"></i> Volver
                </router-link>
                <h6 class="mb-0">Picking / Packing — Remisión #{{ remissionId }}</h6>
              </div>
              <div class="d-flex gap-2">
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-success btn-sm"
                  @click="showPickingModal = true"
                >
                  <i class="fas fa-box me-1"></i> Iniciar Picking / Packing
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #C2185B; border-color: #C2185B; color: #fff;"
                  :disabled="downloadingNote"
                  @click="downloadNote"
                >
                  <i class="fas" :class="downloadingNote ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF pedido
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #6f7a93; border-color: #6f7a93; color: #fff;"
                  :disabled="downloadingNoStock"
                  @click="downloadNoStockNote"
                >
                  <i class="fas" :class="downloadingNoStock ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF prod.
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2e389b; border-color: #2e389b; color: #fff;"
                  :disabled="downloadingNoStockGrouped"
                  @click="downloadNoStockNoteGrouped"
                >
                  <i class="fas" :class="downloadingNoStockGrouped ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF prod. agrupado
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2dce89; border-color: #2dce89; color: #fff;"
                  :disabled="printingBarcodes"
                  @click="printOrderBarcodes"
                >
                  <i class="fas" :class="printingBarcodes ? 'fa-spinner fa-spin' : 'fa-barcode'"></i>
                  Códigos de barras
                </button>
              </div>
            </div>

            <div v-if="loading" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-2x text-success"></i>
              <p class="mt-2 text-sm text-secondary">Cargando detalles...</p>
            </div>

            <div v-else-if="remission" class="mb-3">
              <div class="row">
                <div class="col-md-3">
                  <label class="form-control-label text-xs">Cliente</label>
                  <p class="text-sm font-weight-bold mb-0">{{ remission.name }}</p>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label text-xs">Teléfono</label>
                  <p class="text-sm mb-0">{{ remission.phone }}</p>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label text-xs">Estado</label><br>
                  <span class="badge badge-sm" :class="remission.type === 'return' ? 'bg-danger' : (remission.status == 1 ? 'bg-success' : 'bg-warning')">
                    {{ remission.type === 'return' ? 'Devolución' : (remission.status == 1 ? 'Formalizada' : 'Pendiente') }}
                  </span>
                  <span v-if="remission.preparado == 4" class="badge badge-sm bg-primary ms-1">
                    <i class="fas fa-hammer"></i> Fabricado
                  </span>
                  <span v-else-if="remission.preparado == 1" class="badge badge-sm bg-info text-dark ms-1">
                    <i class="fas fa-check-circle"></i> Preparado
                  </span>
                  <span v-else-if="remission.preparado == 2" class="badge badge-sm bg-success ms-1">
                    <i class="fas fa-check-double"></i> Terminado
                  </span>
                  <span v-else-if="remission.preparado == 5" class="badge badge-sm ms-1" style="background-color: #2e389b; color: #fff;">
                    <i class="fas fa-truck"></i> Despachado
                  </span>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label text-xs">Fecha</label>
                  <p class="text-sm mb-0">{{ new Date(remission.created_at).toLocaleDateString('es-ES') }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="!loading && details.length > 0" class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="width: 40px">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <span>Cód.</span>
                        <input
                          v-if="!isOperator"
                          type="checkbox"
                          style="width: 16px; height: 16px; cursor: pointer; accent-color: #2dce89;"
                          :checked="allBarcodeSelected"
                          @change="toggleSelectAllBarcodes($event)"
                          title="Seleccionar todos para imprimir códigos de barras"
                        />
                      </div>
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Prep.</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <span>Disponible</span>
                        <button
                          v-if="!isOperator && pendingManufacturingItems.length > 0"
                          type="button"
                          class="btn btn-sm btn-manufacture-all"
                          :disabled="markingAllManufactured"
                          @click="markAllManufactured"
                          title="Marcar todos los productos pendientes como fabricados"
                        >
                          <i class="fas" :class="markingAllManufactured ? 'fa-spinner fa-spin' : 'fa-hammer'"></i>
                          Marcar todos fabricados
                        </button>
                      </div>
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Talla</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Color</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código de barras</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant / Stock</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in details" :key="item.id">
                    <td class="text-center align-middle">
                      <input
                        v-if="!isOperator"
                        type="checkbox"
                        style="width: 16px; height: 16px; cursor: pointer; accent-color: #2dce89;"
                        :value="item.id"
                        v-model="selectedBarcodeIds"
                        title="Seleccionar para imprimir código de barras"
                      />
                    </td>
                    <td class="text-center align-middle">
                      <div v-if="item.prepared" class="d-flex flex-column align-items-center">
                        <i class="fas fa-check-circle text-success" title="Preparado"></i>
                      </div>
                      <div v-else-if="(item.scanned_quantity || 0) > 0" class="d-flex flex-column align-items-center">
                        <i class="fas fa-spinner text-warning" title="Escaneando"></i>
                        <span class="text-xs text-warning">{{ item.scanned_quantity }}/{{ item.quantity }}</span>
                      </div>
                      <i v-else class="fas fa-clock text-warning" title="No preparado"></i>
                    </td>
                    <td class="text-center align-middle">
                      <i v-if="item.prepared" class="fas fa-check-circle text-success" title="Preparado"></i>
                      <template v-else-if="isProductionOrder || itemStock(item) < item.quantity">
                        <span v-if="itemManufacturingStatus(item) === 'completed'" class="status-badge status-badge--completed">
                          <i class="fas fa-check-circle"></i> Fabricado
                        </span>
                        <select
                          v-else
                          :value="itemManufacturingStatus(item)"
                          class="status-select"
                          :class="statusPillClass(item)"
                          @change="onStatusChange($event, item)"
                        >
                          <option value="pending">Pendiente</option>
                          <option value="in_progress">En proceso</option>
                          <option value="completed">Fabricado</option>
                        </select>
                      </template>
                      <i v-else class="fas fa-check-circle text-success" title="Stock suficiente"></i>
                    </td>
                    <td class="align-middle">
                      <h6 class="mb-0 text-sm">{{ item.inventory?.name || 'Producto' }}</h6>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs text-secondary">{{ item.inventory?.ref || '—' }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs text-secondary">{{ itemSize(item) }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs text-secondary">{{ itemColor(item) }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs text-secondary">{{ itemBarcode(item) }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-sm font-weight-bold">{{ item.quantity }}</span> / 
                      <span class="badge badge-sm" :class="itemStock(item) <= 0 ? 'bg-danger' : (itemStock(item) < item.quantity ? 'bg-warning text-dark' : 'bg-success')">
                        {{ itemStock(item) }}
                      </span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs text-secondary">{{ parseFloat(item.unit_price || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs font-weight-bold">{{ parseFloat(item.total || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="px-4 py-3 d-flex gap-2">
                <span class="badge bg-secondary">Pendientes: {{ statusCount('pending') }}</span>
                <span class="badge bg-info text-dark">En proceso: {{ statusCount('in_progress') }}</span>
                <span class="badge bg-success">Fabricados: {{ statusCount('completed') }}</span>
              </div>
            </div>

            <div v-else-if="!loading" class="text-center py-4">
              <p class="text-secondary text-sm">No hay detalles para esta remisión.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Picking / Packing -->
    <div v-if="showPickingModal" class="picking-modal-overlay" @click.self="showPickingModal = false">
      <div class="picking-modal-box card shadow">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">Escanear producto — Remisión #{{ remissionId }}</h6>
            <button type="button" class="btn-close" @click="showPickingModal = false"></button>
          </div>

          <div class="picking-summary mb-3">
            <span class="badge bg-success">Escaneadas: {{ scannedUnits }} / {{ totalUnits }}</span>
            <span class="badge bg-warning text-dark">Items preparados: {{ preparedCount }} / {{ details.length }}</span>
          </div>

          
          <!-- Barra de progreso -->
          <div class="picking-progress mb-3">
            <div class="picking-progress-bar" :style="{ width: progressPercent + '%' }"></div>
          </div>
          <div class="text-center text-xs text-secondary mb-3">
            {{ scannedUnits }} / {{ totalUnits }} pares ({{ progressPercent }}%)
          </div>

          <label class="form-control-label text-sm">Escanear código de barras</label>
          <div class="d-flex gap-2 mb-3">
            <input
              ref="barcodeInput"
              v-model="barcodeScan"
              type="text"
              class="form-control form-control-sm"
              placeholder="Escanee o digite el código de barras..."
              @input="onBarcodeInput"
              @keyup.enter="onBarcodeScan"
            />
            <button type="button" class="btn btn-success btn-sm d-flex align-items-center justify-content-center" @click="onBarcodeScan" :disabled="!barcodeScan.trim()" style="margin-bottom: 0; flex-shrink: 0;">
              <i class="fas fa-check"></i>
            </button>
          </div>
          <div v-if="scanMessage" class="mt-2 mb-3" :class="scanError ? 'text-danger' : 'text-success'">
            <small>{{ scanMessage }}</small>
          </div>

          <div class="picking-items-list">
            <div
              v-for="unit in pickingUnits"
              :key="unit.key"
              class="picking-item-row"
              :class="{ 'picking-item-row--prepared': unit.done }"
            >
              <div class="picking-item-status">
                <i v-if="unit.done" class="fas fa-check-circle text-success"></i>
                <i v-else-if="unit.inProduction" class="fas fa-industry text-secondary" title="En producción"></i>
                <i v-else class="fas fa-clock text-warning"></i>
              </div>
              <div class="picking-item-info">
                <div class="picking-item-name">
                  {{ unit.item.inventory?.name || 'Producto' }}
                  <span v-if="unit.inProduction" class="badge badge-sm bg-secondary ms-1">En producción</span>
                </div>
                <div class="picking-item-meta">
                  Ref: {{ unit.item.inventory?.ref || '—' }} ·
                  Talla: {{ itemSize(unit.item) }} ·
                  Color: {{ itemColor(unit.item) }} ·
                  Unidad {{ unit.unitIndex }} de {{ unit.unitTotal }} ·
                  Barcode: {{ itemBarcode(unit.item) }}
                </div>
              </div>
              <div v-if="!unit.done && !unit.inProduction" class="picking-item-actions">
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm mb-0"
                  title="Marcar 1 unidad como preparada"
                  :disabled="manualMarkingId === unit.item.id"
                  @click="markUnitPrepared(unit.item)"
                >
                  <i class="fas" :class="manualMarkingId === unit.item.id ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="showPickingModal = false">
              <i class="fas fa-times me-1"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Códigos de barras (cantidad editable por artículo) -->
    <div v-if="showBarcodeModal" class="picking-modal-overlay" @click.self="cancelBarcodeModal">
      <div class="picking-modal-box card shadow" style="max-width: 640px;">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">Imprimir códigos de barras — Remisión #{{ remissionId }}</h6>
            <button type="button" class="btn-close" @click="cancelBarcodeModal"></button>
          </div>
          <p class="text-xs text-secondary mb-3">
            Ajuste la cantidad de etiquetas a imprimir por artículo. Por defecto toma la cantidad del artículo.
          </p>

          <div class="barcode-items-list">
            <div
              v-for="row in barcodeModalItems"
              :key="row.id"
              class="barcode-item-row"
            >
              <div class="barcode-item-info">
                <div class="barcode-item-name">{{ row.name }}</div>
                <div class="barcode-item-meta">
                  Talla: {{ row.size }} · Color: {{ row.color }} · Cód: {{ row.barcode }}
                </div>
              </div>
              <div class="barcode-item-qty">
                <label class="form-control-label text-xs mb-0">Etiquetas</label>
                <input
                  type="number"
                  min="0"
                  step="1"
                  class="form-control form-control-sm"
                  style="width: 90px;"
                  v-model.number="row.quantity"
                />
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelBarcodeModal">
              <i class="fas fa-times me-1"></i> Cancelar
            </button>
            <button type="button" class="btn btn-sm" style="background-color: #2dce89; border-color: #2dce89; color: #fff;" @click="confirmBarcodeModal">
              <i class="fas fa-print me-1"></i> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import JsBarcode from 'jsbarcode';
import remissionsService from '@/services/remissions.service';
import remissionsDetailsService from '@/services/remissionsDetails.service';

export default {
  name: 'PickingPacking',
  data() {
    return {
      remissionId: null,
      remission: null,
      details: [],
      loading: true,
      showPickingModal: false,
      barcodeScan: '',
      scanMessage: '',
      scanError: false,
      manualMarkingId: null,
      downloadingNote: false,
      downloadingNoStock: false,
      downloadingNoStockGrouped: false,
      printingBarcodes: false,
      markingAllManufactured: false,
      selectedBarcodeIds: [],
      showBarcodeModal: false,
      barcodeModalItems: [],
    };
  },
  computed: {
    isOperator() {
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      return user?.role === '3' || user?.role === 3;
    },
    allBarcodeSelected() {
      return this.details.length > 0 && this.details.every((d) => this.selectedBarcodeIds.includes(d.id));
    },
    isProductionOrder() {
      // Pedidos de producción (is_production_order=1): no se valida stock en la
      // columna Disponible, siempre se muestra el estado para pasar a En proceso.
      // Las remisiones tipo venta (is_production_order=0) sí validan stock.
      return !!(this.remission?.is_production_order);
    },
    preparedCount() {
      return this.details.filter(d => d.prepared).length;
    },
    scannedUnits() {
      return this.pickingUnits.filter((u) => u.done).length;
    },
    // Solo cuentan para el progreso las unidades con stock disponible;
    // las que están en producción no hacen parte del picking.
    totalUnits() {
      return this.pickingUnits.filter((u) => !u.inProduction).length;
    },
    progressPercent() {
      if (this.totalUnits === 0) return 0;
      return Math.round((this.scannedUnits / this.totalUnits) * 100);
    },
    sortedDetails() {
      return [...this.details].sort((a, b) => {
        if (a.prepared === b.prepared) return 0;
        return a.prepared ? 1 : -1;
      });
    },
    // Expande cada detalle en una fila por unidad para el modal de picking.
    // Un item con quantity=3 genera 3 registros; cada uno sabe si ya fue
    // escaneado (unitIndex <= scanned_quantity) o si está en producción
    // (las unidades que exceden el stock disponible no cuentan como pendientes).
    pickingUnits() {
      const units = [];
      for (const item of this.sortedDetails) {
        const total = Math.max(parseInt(item.quantity) || 0, 1);
        const scanned = item.prepared
          ? total
          : Math.min(parseInt(item.scanned_quantity) || 0, total);
        const stock = this.pickableStock(item);
        for (let i = 1; i <= total; i++) {
          const done = i <= scanned;
          units.push({
            key: `${item.id}-${i}`,
            item,
            unitIndex: i,
            unitTotal: total,
            done,
            inProduction: !done && (i - scanned) > stock,
          });
        }
      }
      // Pendientes primero, luego las de producción y al final las escaneadas
      const rank = (u) => (u.done ? 2 : (u.inProduction ? 1 : 0));
      return units.sort((a, b) => rank(a) - rank(b));
    },
    // Items que aún muestran el select de estado de fabricación y no están completed
    pendingManufacturingItems() {
      return this.details.filter(item => {
        if (item.prepared) return false;
        if (this.itemManufacturingStatus(item) === 'completed') return false;
        // Mismo criterio que usa el template para mostrar el select
        return this.isProductionOrder || this.itemStock(item) < item.quantity;
      });
    },
  },
  methods: {
    itemManufacturingStatus(item) {
      return item.manufacturing_status || 'pending';
    },
    statusLabel(item) {
      const s = this.itemManufacturingStatus(item);
      if (s === 'completed') return 'Fabricado';
      if (s === 'in_progress') return 'En proceso';
      return 'Pendiente';
    },
    statusPillClass(item) {
      const s = this.itemManufacturingStatus(item);
      if (s === 'completed') return 'status-pill--completed';
      if (s === 'in_progress') return 'status-pill--in-progress';
      return 'status-pill--pending';
    },
    statusIconClass(item) {
      const s = this.itemManufacturingStatus(item);
      if (s === 'completed') return 'fas fa-check-circle';
      if (s === 'in_progress') return 'fas fa-cog fa-spin';
      return 'fas fa-clock';
    },
    statusCount(status) {
      return this.details.filter(d => this.itemManufacturingStatus(d) === status).length;
    },
    revertStatus(target, item, current) {
      target.value = current;
      item.manufacturing_status = current;
    },
    async onStatusChange(event, item) {
      const newStatus = event.target.value;
      const current = this.itemManufacturingStatus(item);
      const target = event.target;

      if (newStatus === current) return;

      if (newStatus === 'completed') {
        const result = await Swal.fire({
          title: 'Confirmar fabricado',
          text: `¿Cambiar el estado de "${item.inventory?.name || 'Producto'}" a Fabricado? Se sumarán ${item.quantity} unidades al inventario.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, marcar fabricado',
          cancelButtonText: 'Cancelar',
          customClass: {
            container: 'swal-high-z',
            popup: 'swal-status-popup',
            confirmButton: 'swal-status-confirm',
            cancelButton: 'swal-status-cancel',
          },
        });

        if (!result.isConfirmed) {
          this.revertStatus(target, item, current);
          return;
        }
      }

      try {
        const res = await remissionsDetailsService.updateManufacturingStatus(item.id, newStatus);
        const updated = res.data.detail;
        const idx = this.details.findIndex(d => d.id === item.id);
        if (idx >= 0) {
          this.details[idx] = {
            ...this.details[idx],
            manufacturing_status: updated.manufacturing_status,
            manufactured: updated.manufactured,
            inventory: updated.inventory,
            variant: updated.variant,
            available_stock: updated.available_stock,
          };
        }
        await Swal.fire({
          icon: 'success',
          title: 'Estado actualizado',
          text: res.data.message,
          timer: 1500,
          showConfirmButton: false,
          customClass: { container: 'swal-high-z' },
        });

        // Si el backend cambió el preparado de la remisión a En proceso (3)
        if (res.data.remission_preparado_changed) {
          this.remission = { ...this.remission, preparado: res.data.remission_preparado };
        }
      } catch (error) {
        console.error('Error al actualizar estado:', error);
        this.revertStatus(target, item, current);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo actualizar el estado',
          customClass: { container: 'swal-high-z' },
        });
      }
    },
    async markAllManufactured() {
      const items = this.pendingManufacturingItems;
      if (items.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Nada que fabricar',
          text: 'No hay productos pendientes por fabricar.',
          customClass: { container: 'swal-high-z' },
        });
        return;
      }

      const totalQty = items.reduce((acc, i) => acc + (parseInt(i.quantity) || 0), 0);
      const result = await Swal.fire({
        title: 'Marcar todos como fabricados',
        html: `Se marcarán <b>${items.length}</b> producto(s) como fabricados y se sumarán <b>${totalQty}</b> unidad(es) al inventario. ¿Deseas continuar?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, marcar todos',
        cancelButtonText: 'Cancelar',
        customClass: {
          container: 'swal-high-z',
          confirmButton: 'swal-status-confirm',
          cancelButton: 'swal-status-cancel',
        },
      });
      if (!result.isConfirmed) return;

      this.markingAllManufactured = true;
      let success = 0;
      let failed = 0;
      let lastPreparadoChanged = false;
      let lastPreparadoValue = null;

      try {
        for (const item of items) {
          try {
            const res = await remissionsDetailsService.updateManufacturingStatus(item.id, 'completed');
            const updated = res.data.detail;
            const idx = this.details.findIndex(d => d.id === item.id);
            if (idx >= 0) {
              this.details[idx] = {
                ...this.details[idx],
                manufacturing_status: updated.manufacturing_status,
                manufactured: updated.manufactured,
                inventory: updated.inventory,
                variant: updated.variant,
                available_stock: updated.available_stock,
              };
            }
            if (res.data.remission_preparado_changed) {
              lastPreparadoChanged = true;
              lastPreparadoValue = res.data.remission_preparado;
            }
            success++;
          } catch (err) {
            console.error('Error al marcar fabricado (item', item.id, '):', err);
            failed++;
          }
        }

        if (lastPreparadoChanged) {
          this.remission = { ...this.remission, preparado: lastPreparadoValue };
        }

        await Swal.fire({
          icon: failed === 0 ? 'success' : (success > 0 ? 'warning' : 'error'),
          title: failed === 0 ? '¡Listo!' : 'Proceso finalizado',
          html: `Fabricados: <b>${success}</b> de ${items.length}.` + (failed > 0 ? `<br>Fallidos: <b>${failed}</b>.` : ''),
          customClass: { container: 'swal-high-z' },
        });
      } finally {
        this.markingAllManufactured = false;
      }
    },
    itemSize(item) {
      if (item.variant?.size?.size) return item.variant.size.size;
      if (item.productionModel?.size?.size) return item.productionModel.size.size;
      return '—';
    },
    itemColor(item) {
      if (item.variant?.color?.name) return item.variant.color.name;
      if (item.productionModel?.size?.color?.name) return item.productionModel.size.color.name;
      if (item.inventory?.color?.name) return item.inventory.color.name;
      return '—';
    },
    itemStock(item) {
      // available_stock ya descuenta las cantidades apartadas por pedidos Fabricados
      if (item.available_stock !== undefined && item.available_stock !== null) {
        return item.available_stock;
      }
      if (item.variant) {
        return item.variant.quantity ?? 0;
      }
      return item.inventory?.quantity ?? 0;
    },
    itemBarcode(item) {
      if (item.variant && item.variant.barcode) return item.variant.barcode;
      return item.inventory?.barcode || '—';
    },
    // Unidades con stock disponible para picking. Si el inventario no maneja
    // stock (o el detalle no tiene inventario) el backend no valida stock,
    // así que todas las unidades cuentan como disponibles.
    pickableStock(item) {
      if (!item.variant && (!item.inventory || !item.inventory.manage_stock)) return Infinity;
      return Math.max(0, this.itemStock(item));
    },
    // Descuenta localmente las unidades ya marcadas para que el conteo de
    // disponibles del modal se mantenga en sync con el backend.
    decrementLocalStock(item, units = 1) {
      const unitsNum = Math.max(0, parseInt(units) || 0);
      if (unitsNum === 0) return;
      if (item.available_stock !== undefined && item.available_stock !== null) {
        item.available_stock = Math.max(0, item.available_stock - unitsNum);
      } else if (item.variant) {
        item.variant.quantity = Math.max(0, (item.variant.quantity ?? 0) - unitsNum);
      } else if (item.inventory) {
        item.inventory.quantity = Math.max(0, (item.inventory.quantity ?? 0) - unitsNum);
      }
    },
    async printOrderBarcodes() {
      if (this.details.length === 0) {
        await Swal.fire('Atención', 'No hay productos para generar códigos.', 'warning');
        return;
      }
      // Si hay registros seleccionados, abrir modal para ajustar cantidades
      if (this.selectedBarcodeIds.length > 0) {
        this.openBarcodeModal();
        return;
      }
      // Sin selección: comportamiento original (imprime los faltantes de toda la orden)
      this.printingBarcodes = true;
      try {
        const entries = [];
        for (const item of this.details) {
          const stock = this.itemStock(item);
          const qty = parseInt(item.quantity) || 0;
          // Si es pedido de producción, imprimir todos los códigos según qty
          // (ignorar la comparación de stock). Si es venta, solo los faltantes.
          let faltantes;
          if (this.isProductionOrder) {
            faltantes = qty;
          } else {
            faltantes = qty - stock;
          }
          if (faltantes <= 0) continue;
          const barcode = this.itemBarcode(item);
          if (!barcode || barcode === '—') continue;
          const name = item.inventory?.name || 'PRODUCTO';
          const size = this.itemSize(item);
          const color = this.itemColor(item);
          const desc = [name, size !== '—' ? size : '', color !== '—' ? color : ''].filter(Boolean).join(' ');
          entries.push({ desc, barcode, count: faltantes });
        }
        await this.renderAndPrintLabels(entries);
      } catch (error) {
        console.error('Error al generar códigos de barras:', error);
        await Swal.fire('Error', 'No se pudieron generar los códigos de barras.', 'error');
      } finally {
        this.printingBarcodes = false;
      }
    },
    toggleSelectAllBarcodes(event) {
      if (event.target.checked) {
        this.selectedBarcodeIds = this.details.map((d) => d.id);
      } else {
        this.selectedBarcodeIds = [];
      }
    },
    openBarcodeModal() {
      const selected = this.details.filter((d) => this.selectedBarcodeIds.includes(d.id));
      this.barcodeModalItems = selected.map((item) => {
        const barcode = this.itemBarcode(item);
        const name = item.inventory?.name || 'PRODUCTO';
        const size = this.itemSize(item);
        const color = this.itemColor(item);
        const desc = [name, size !== '—' ? size : '', color !== '—' ? color : ''].filter(Boolean).join(' ');
        return {
          id: item.id,
          name,
          size,
          color,
          barcode,
          desc,
          quantity: parseInt(item.quantity) || 0,
        };
      });
      this.showBarcodeModal = true;
    },
    cancelBarcodeModal() {
      this.showBarcodeModal = false;
      this.barcodeModalItems = [];
    },
    async confirmBarcodeModal() {
      const valid = this.barcodeModalItems.filter((row) => {
        const q = parseInt(row.quantity);
        return !Number.isNaN(q) && q > 0 && row.barcode && row.barcode !== '—';
      });
      if (valid.length === 0) {
        await Swal.fire('Atención', 'No hay artículos con cantidad válida o código de barras para imprimir.', 'warning');
        return;
      }
      const entries = valid.map((row) => ({ desc: row.desc, barcode: row.barcode, count: parseInt(row.quantity) }));
      this.showBarcodeModal = false;
      this.printingBarcodes = true;
      try {
        await this.renderAndPrintLabels(entries);
      } catch (error) {
        console.error('Error al generar códigos de barras:', error);
        await Swal.fire('Error', 'No se pudieron generar los códigos de barras.', 'error');
      } finally {
        this.printingBarcodes = false;
        this.barcodeModalItems = [];
      }
    },
    async renderAndPrintLabels(entries) {
      const labels = [];
      for (const entry of entries) {
        const { desc, barcode, count } = entry;
        for (let i = 0; i < count; i++) {
          const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          JsBarcode(tmpSvg, String(barcode), {
            format: 'CODE128',
            displayValue: false,
            fontSize: 12,
            height: 50,
            margin: 0,
            width: 2,
          });
          const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);
          labels.push(`
            <div class="label">
              <div class="label-header">
                <span class="label-name">${desc}</span>
              </div>
              <div class="label-body">${barcodeSvg}</div>
              <div class="label-number">${barcode}</div>
            </div>`);
        }
      }
      if (labels.length === 0) {
        await Swal.fire('Atención', 'No hay productos para generar códigos de barras.', 'warning');
        return;
      }
      let rows = '';
      const remainder = labels.length % 3;
      if (remainder > 0) {
        for (let i = 0; i < (3 - remainder); i++) {
          labels.push('<div class="label label-empty"></div>');
        }
      }
      for (let i = 0; i < labels.length; i++) {
        if (i % 3 === 0) rows += '<div class="label-row">';
        rows += labels[i];
        if (i % 3 === 2 || i === labels.length - 1) rows += '</div>';
      }
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <title>Imprimir códigos de barras</title>
          <style>
            @page { size: 104mm 25mm; margin: 0; }
            * { box-sizing: border-box; }
            html, body { margin: 0; padding: 0; }
            .label-row {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 104mm;
              height: 25mm;
              page-break-after: always;
            }
            .label {
              width: 34mm;
              height: 25mm;
              padding: 4mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-family: Arial, Helvetica, sans-serif;
              overflow: hidden;
            }
            .label-empty {
              visibility: hidden;
            }
            .label-header {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              width: 100%;
            }
            .label-name {
              font-size: 7pt;
              font-weight: bold;
              word-break: break-word;
              line-height: 1.1;
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .label-body {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .label-body svg {
              width: 100%;
              height: auto;
              max-height: 10mm;
              display: block;
            }
            .label-number {
              font-size: 7pt;
              font-weight: bold;
              text-align: center;
              width: 100%;
              letter-spacing: 0.5pt;
            }
          </style>
        </head>
        <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
          ${rows}
        </body>
        </html>`;
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (!printWindow) {
        await Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
        return;
      }
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
    },
    async downloadNoStockNote() {
      this.downloadingNoStock = true;
      try {
        const response = await remissionsService.getNoStockNote(this.remissionId);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `nota_sin_stock_${this.remissionId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar el PDF sin stock:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF sin stock', 'error');
      } finally {
        this.downloadingNoStock = false;
      }
    },
    async downloadNoStockNoteGrouped() {
      this.downloadingNoStockGrouped = true;
      try {
        const response = await remissionsService.getNoStockNoteGrouped(this.remissionId);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `nota_prod_agrupada_${this.remissionId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar el PDF agrupado:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF agrupado', 'error');
      } finally {
        this.downloadingNoStockGrouped = false;
      }
    },
    async loadData() {
      this.remissionId = this.$route.query.id;
      if (!this.remissionId) {
        this.loading = false;
        return;
      }
      try {
        const [remRes, detRes] = await Promise.all([
          remissionsService.getData(this.remissionId),
          remissionsDetailsService.getData(this.remissionId),
        ]);
        this.remission = remRes.data;
        this.details = (detRes.data || []).map(d => ({
          ...d,
          prepared: !!d.prepared,
          scanned_quantity: d.scanned_quantity || 0,
        }));
      } catch (error) {
        console.error('Error al cargar datos:', error);
        await Swal.fire('Error', 'No se pudieron cargar los datos de la remisión', 'error');
      } finally {
        this.loading = false;
      }
    },
    onBarcodeInput() {
      clearTimeout(this._barcodeTimer);
      const code = this.barcodeScan.trim();
      if (!code) return;
      this._barcodeTimer = setTimeout(() => {
        const match = this.details.find(d => {
          if (d.variant && d.variant.barcode) {
            return d.variant.barcode === code;
          }
          const inv = d.inventory;
          if (!inv) return false;
          if (inv.barcode === code) return true;
          const variants = inv.shopify_details?.variants || [];
          return variants.some(v => v.barcode === code);
        });
        if (match) {
          this.onBarcodeScan();
        }
      }, 300);
    },
    async downloadNote() {
      this.downloadingNote = true;
      try {
        const response = await remissionsService.getNote(this.remissionId);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `nota_envio_${this.remissionId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF', 'error');
      } finally {
        this.downloadingNote = false;
      }
    },
    async onBarcodeScan() {
      const code = this.barcodeScan.trim();
      if (!code) return;
      // Evitar dobles procesamientos (debounce del input + Enter del escáner)
      if (this._scanning) return;
      this._scanning = true;
      clearTimeout(this._barcodeTimer);
      this.scanMessage = '';
      this.scanError = false;
      try {
        const res = await remissionsService.markPrepared(this.remissionId, code);
        const detailId = res.data.detail?.id;
        if (detailId) {
          const item = this.details.find(d => d.id === detailId);
          if (item) {
            const before = item.scanned_quantity || 0;
            item.scanned_quantity = res.data.scanned_quantity ?? item.scanned_quantity;
            item.prepared = !!res.data.detail?.prepared;
            this.decrementLocalStock(item, item.scanned_quantity - before);
          }
        }
        this.scanMessage = res.data.message || 'Producto marcado como preparado';

        if (res.data.remission_preparado) {
          this.remission = { ...this.remission, preparado: true };
          await Swal.fire({
            icon: 'success',
            title: '¡Pedido preparado!',
            text: 'Todos los productos han sido marcados como preparados.',
            timer: 2000,
            showConfirmButton: false,
            customClass: { container: 'swal-high-z' },
          });
        }

        this.barcodeScan = '';
        this.$nextTick(() => {
          if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus();
        });
      } catch (error) {
        this.scanError = true;
        this.scanMessage = error.response?.data?.message || 'Error al marcar el producto';
        if (error.response?.status === 422) {
          await Swal.fire({
            icon: 'warning',
            title: 'Stock insuficiente',
            text: error.response?.data?.message || 'No hay stock suficiente',
            customClass: {
              container: 'swal-high-z',
            },
          });
        }
        this.barcodeScan = '';
        this.$nextTick(() => {
          if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus();
        });
      } finally {
        this._scanning = false;
      }
    },
    async markUnitPrepared(item) {
      this.manualMarkingId = item.id;
      this.scanMessage = '';
      this.scanError = false;
      try {
        // Marca una sola unidad usando el mismo endpoint del escáner.
        // Si el producto no tiene barcode no hay forma de marcar 1 unidad,
        // entonces se marca toda la línea como antes.
        const barcode = this.itemBarcode(item);
        const res = (!barcode || barcode === '—')
          ? await remissionsService.markPreparedById(item.id)
          : await remissionsService.markPrepared(this.remissionId, barcode);
        const detailId = res.data.detail?.id ?? item.id;
        const idx = this.details.findIndex(d => d.id === detailId);
        if (idx >= 0) {
          const before = this.details[idx].scanned_quantity || 0;
          this.details[idx].scanned_quantity = res.data.scanned_quantity ?? this.details[idx].scanned_quantity;
          this.details[idx].prepared = !!res.data.detail?.prepared;
          this.decrementLocalStock(this.details[idx], this.details[idx].scanned_quantity - before);
        }
        this.scanMessage = res.data.message || 'Unidad marcada como preparada';

        if (res.data.remission_preparado) {
          this.remission = { ...this.remission, preparado: true };
          await Swal.fire({
            icon: 'success',
            title: '¡Pedido preparado!',
            text: 'Todos los productos han sido marcados como preparados.',
            timer: 2000,
            showConfirmButton: false,
            customClass: { container: 'swal-high-z' },
          });
        }
      } catch (error) {
        this.scanError = true;
        this.scanMessage = error.response?.data?.message || 'Error al marcar el producto';
        if (error.response?.status === 422) {
          await Swal.fire({
            icon: 'warning',
            title: 'Stock insuficiente',
            text: error.response?.data?.message || 'No hay stock suficiente',
            customClass: { container: 'swal-high-z' },
          });
        }
      } finally {
        this.manualMarkingId = null;
      }
    },
  },
  watch: {
    showPickingModal(val) {
      if (val) {
        this.barcodeScan = '';
        this.scanMessage = '';
        this.scanError = false;
        this.$nextTick(() => {
          if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus();
        });
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style scoped>
.btn-manufacture-all {
  background-color: #2dce89;
  border-color: #2dce89;
  color: #fff;
  font-size: 0.65rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  white-space: nowrap;
}
.btn-manufacture-all:hover:not(:disabled) {
  background-color: #26b878;
  border-color: #26b878;
  color: #fff;
}
.btn-manufacture-all:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.picking-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.picking-modal-box {
  width: 600px;
  max-width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}

.picking-summary {
  display: flex;
  gap: 0.5rem;
}

.picking-progress {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 999px;
  overflow: hidden;
}

.picking-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #82d616, #4caf50);
  border-radius: 999px;
  transition: width 0.4s ease;
}

.picking-item-actions {
  flex-shrink: 0;
}

.picking-items-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.picking-item-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #f1f1f1;
}

.picking-item-row:last-child {
  border-bottom: none;
}

.picking-item-row--prepared {
  background: #f0fff4;
}

/* Modal códigos de barras */
.barcode-items-list {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.barcode-item-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #f1f1f1;
}

.barcode-item-row:last-child {
  border-bottom: none;
}

.barcode-item-info {
  flex: 1;
  min-width: 0;
}

.barcode-item-name {
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.barcode-item-meta {
  font-size: 0.72rem;
  color: #6c757d;
}

.barcode-item-qty {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.picking-item-status {
  font-size: 1.1rem;
  flex-shrink: 0;
}

.picking-item-info {
  flex: 1;
  min-width: 0;
}

.picking-item-name {
  font-weight: 600;
  font-size: 0.875rem;
}

.picking-item-meta {
  font-size: 0.75rem;
  color: #6c757d;
}

.status-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.3rem 1.8rem 0.3rem 0.8rem;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1.2;
  outline: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='currentColor' viewBox='0 0 16 16'%3e%3cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.55rem center;
  background-size: 10px;
}

.status-select:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.status-select:focus {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.status-select option {
  font-size: 0.85rem;
  padding: 0.3rem 0.5rem;
  border-radius: 0;
}

.status-pill--pending {
  background: #f3f4f6;
  color: #6b7280;
}

.status-pill--pending:hover {
  background: #e5e7eb;
}

.status-pill--in-progress {
  background: #fef3c7;
  color: #b45309;
}

.status-pill--in-progress:hover {
  background: #fde68a;
}

.status-pill--completed {
  background: #d1fae5;
  color: #047857;
}

.status-pill--completed:hover {
  background: #a7f3d0;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(1.3); }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.3rem 0.8rem;
  border-radius: 999px;
  white-space: nowrap;
  line-height: 1.2;
}

.status-badge--completed {
  background: #d1fae5;
  color: #047857;
}
</style>

<style>
.swal-high-z {
  z-index: 100000 !important;
}

.swal-status-popup {
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

.swal-status-select {
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  padding: 0.7rem 2.5rem 0.7rem 1rem !important;
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  color: #334155 !important;
  background-color: #f8fafc !important;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%2364748b' viewBox='0 0 16 16'%3e%3cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.85rem center !important;
  background-size: 14px !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  margin-top: 0.75rem !important;
}

.swal-status-select:focus {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12) !important;
  outline: none !important;
  background-color: #fff !important;
}

.swal-status-select:hover {
  border-color: #cbd5e1 !important;
  background-color: #f1f5f9 !important;
}

.swal-status-confirm {
  background-color: #6366f1 !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  padding: 0.6rem 1.5rem !important;
  font-size: 0.9rem !important;
  transition: all 0.2s ease !important;
}

.swal-status-confirm:hover {
  background-color: #4f46e5 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3) !important;
}

.swal-status-cancel {
  border-radius: 10px !important;
  font-weight: 600 !important;
  padding: 0.6rem 1.5rem !important;
  font-size: 0.9rem !important;
  transition: all 0.2s ease !important;
}

.swal-status-cancel:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
</style>
